export default {"src":"/_next/static/media/Patent.8d9faabe.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};